const IDLE_TIMEOUT = 3000;

export const isPreloadAllowed = () => !navigator.connection?.saveData;

export const onIdleAfterLoad = (callback) => {
    const schedule = () => {
        if (window.requestIdleCallback) {
            window.requestIdleCallback(callback, { timeout: IDLE_TIMEOUT });

            return;
        }

        window.setTimeout(callback, 200);
    };

    if (document.readyState === 'complete') {
        schedule();

        return;
    }

    window.addEventListener('load', schedule, { once: true });
};

export const preloadImages = (sources) => sources.forEach((src) => {
    const image = new Image();

    image.src = src;
});

export const whenImagesLoaded = (sources, timeoutMs) => new Promise((resolve) => {
    let remaining = sources.length;

    if (remaining === 0) {
        resolve();

        return;
    }

    const timer = window.setTimeout(resolve, timeoutMs);

    const settle = () => {
        remaining -= 1;

        if (remaining === 0) {
            window.clearTimeout(timer);
            resolve();
        }
    };

    sources.forEach((src) => {
        const image = new Image();

        image.addEventListener('load', settle, { once: true });
        image.addEventListener('error', settle, { once: true });
        image.src = src;
    });
});
